import {  OfferUpdateSlider } from "../Model/Offer";
import { OffersPromoRepository } from "../Repository/OffersPromoRepository";


export interface GetOfferSliderByIdUseCase {
  invoke: (id: number) => Promise<OfferUpdateSlider | null>;
}

export class GetOfferSliderById implements GetOfferSliderByIdUseCase {
  private Repo: OffersPromoRepository;
  constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
  }

   invoke(id: number){
    if(!id){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
    const getData = this.Repo.getOfferSliderById(id);
    return getData;
  }
}